<template>
  <div>
    <div style="display: flex; align-items: center">
      <v-btn class="mr-3"
             icon
             large
             text
             color="primary"
             @click="copyText(facebookMessengerRoute)">
        <v-icon color="kbGray">
          file_copy
        </v-icon>
      </v-btn>

      <div style="flex: auto">
        <div class="text-h6 font-weight-bold">
          URL
        </div>

        <p class="collapse-text">
          {{facebookMessengerRoute}}
        </p>
      </div>
    </div>

    <v-card-text>
      <v-form ref="facebookForm"
              lazy-validation
              :value="valid">
        <v-row>
          <v-col cols="12">
            <v-text-field label="Page Id"
                          color="kbDarkBlue"
                          :rules="[rules.required]"
                          v-model="fbInfo.pageId[0]">
            </v-text-field>
          </v-col>

          <v-col cols="12">
            <v-text-field label="Verification Token"
                          color="kbDarkBlue"
                          :rules="[rules.required]"
                          v-model="fbInfo.verificationToken">
            </v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer/>

      <v-btn class="mr-2"
             color="red"
             @click="deleteFacebookInfo"
             :loading="deleteLoading"
             dark>
        <v-icon dark>
          mdi-delete
        </v-icon>
      </v-btn>

      <v-btn color="kbLightBlue"
             dark
             @click="submit"
             :loading="loading">
             {{this.new === true ? $t('general.create') : $t('general.update')}}
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications.js'
import rules from '@/libs/rules'

export default {
  computed: {
    ...mapState({
      channelsInfo: state => state.conversations.channelsInfo
    }),
    facebookMessengerRoute () {
      const companyId = this.$store.getters.companyUuid
      const appId = this.$store.getters.appUuid
      const subdomain = `conversations${process.env.VUE_APP_NODE_ENV === 'development' ? 'test' : ''}`
      return `https://${subdomain}.keybe.bio/provider/facebook/company/${companyId}/app/${appId}`
    }
  },
  async created () {
    const channelsInfo = await this.$store.dispatch('getChannelsInfo')
    this.$store.commit('SET_CHANNELS_INFO', channelsInfo)
    if (channelsInfo.facebookMessenger) this.setLocalInfo()
  },
  data () {
    return {
      deleteLoading: false,
      fbInfo: {
        pageId: [''],
        verificationToken: ''
      },
      loading: false,
      new: true,
      rules,
      valid: true
    }
  },
  methods: {
    submit () {
      if (!this.$refs.facebookForm.validate()) return

      this.loading = true

      this.new === true ? this.createFacebookInfo() : this.updateFacebookInfo()
    },
    copyText (text) {
      navigator.clipboard.writeText(text).then(() => {
        notifications.success('Ruta copiada correctamente')
      }).catch(() => {
        notifications.error('Error al copiar la ruta')
      })
    },
    async createFacebookInfo () {
      try {
        await this.$store.dispatch('createFbInfo', this.fbInfo)
        notifications.success('información registrada correctamente')
        this.loading = false
        this.new = false
      } catch (e) {
        this.loading = false
        notifications.error(e.message)
      }
    },
    async deleteFacebookInfo () {
      this.deleteLoading = true
      try {
        await this.$store.dispatch('deleteFbInfo')
        notifications.success('Información eliminada correctamente')
        this.deleteLoading = false
        this.new = true
      } catch (error) {
        this.deleteLoading = false
        notifications.error(error.message)
      }
    },
    setLocalInfo () {
      if (!this.channelsInfo || !this.channelsInfo.facebookMessenger) return

      this.fbInfo.pageId = this.channelsInfo.facebookMessenger.page_id
      this.fbInfo.verificationToken = this.channelsInfo.facebookMessenger.verification_token
      this.new = false
    },
    async updateFacebookInfo () {
      try {
        await this.$store.dispatch('updateFbInfo', this.fbInfo)
        notifications.success('información actualizada correctamente')
        this.loading = false
      } catch (e) {
        this.loading = false
        notifications.error(e.message)
      }
    }
  }
}
</script>
